import { Component, EventEmitter, Input, Output, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from "../../../../portal/src/app/shared/shared.module";
import { MaterialModule } from '../../../../portal/src/app/material-module';
import { NavigationExtras, Router } from '@angular/router';
import { DialogPosition, MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ApiService as apiPortalService } from '../../../../portal/src/app/service/api.service';
import { RateRequestDialogComponent } from "../rate-request-dialog/rate-request-dialog.component";
import { CommonService } from '../../../../portal/src/app/service/common.service';
import moment from 'moment';
import { AuthModule } from "../auth/auth.module";

@Component({
  selector: 'app-vs-timeline',
  standalone: true,
  templateUrl: './vs-timeline.component.html',
  styleUrl: './vs-timeline.component.css',
  imports: [CommonModule, SharedModule, MaterialModule, RateRequestDialogComponent, AuthModule]
})

export class VsTimelineComponent {
  @Input() VesselDataList: any;
  @Input() queryParamsData: any;
  @Input() app: any;
  @Input() type: any;
  @Input() loading: any;
  @Input() getObj: any;
  viewvessel: any = {};
  dialogRef: any;
  bookingRef: any;
  rateSearch: any;
  singleRate: any;
  isPopup = false;
  reqDialogRef: any;
  rateList: any = [];
  isLoading = false;
  bottomSheetDialogRef: any;
  rateRequestInfo: any = [];
  chargeListObj = {
    freight_charge: <any>null,
    origin_charge: <any>null,
    destination_charge: <any>null,
  }
  vesselMetadata = [
    { name: 'liner', dname: '', type: 'text' },
    { name: 'departure_date', dname: 'Departure', type: 'date' },
    { name: 'transits_days', dname: 'Transit Time', type: 'text' },
    { name: 'arrival_date', dname: 'Arrival', type: 'date' },
    { name: 'vessel_name', dname: 'Vessel', type: 'text' },
    { name: 'voyage_no', dname: 'Voyage', type: 'text' },
  ];
  DomainType: string = 'portal';
  authType: string = 'login' // for website
  userInfo: any;

  constructor(private route: Router,
    private dialog: MatDialog,
    private _bottomSheet: MatBottomSheet,
    private commonService: CommonService,
    private apiPortalService: apiPortalService,) { }

  ngOnInit(): void {
    if (!!location.pathname.includes("/vessel-schedules/")) {
      this.DomainType = 'website';
    }
  }

  expand(indexas: any) {
    this.viewvessel[indexas] = !this.viewvessel[indexas];
  }

  encodeUriComponent(value: string): string {
    return encodeURIComponent(value);
  }

  getDaysDifference(date1: string, date2: string): number {
    const diffTime = new Date(date2).getTime() - new Date(date1).getTime();
    const diffDays = Math.floor((diffTime / (1000 * 60 * 60 * 24)) - 1);
    return diffDays >= 0 ? diffDays : 0;
  }

  selectedDataDialog(template, data) {
    this.rateSearch = data;
    this.getRates();
    this.dialogRef = this.dialog.open(template, {
      width: '660px',
      height: '100%',
      disableClose: true,
      autoFocus: false,
      position: { right: '0', top: '0' }
    })
    this.isPopup = true
  }

  selectedDataSheet(template, data): void {
    this.rateSearch = data;
    this.getRates();
    this.bottomSheetDialogRef = this._bottomSheet.open(template);
  }

  close() {
    if (!!this.dialogRef) {
      this.dialogRef.close();
      this.isPopup = false;
      this.rateList = [];
    }
    if (!!this.bottomSheetDialogRef) {
      this.bottomSheetDialogRef.dismiss();
      this.isPopup = false;
      this.rateList = [];
    }
  }
  closeRequest() {
    if (!!this.reqDialogRef) {
      this.reqDialogRef.close();
    }
    if (!!this.bottomSheetDialogRef) {
      this.bottomSheetDialogRef.dismiss();
    }
  }
  openConfirmationDialog(template, data) {
    this.singleRate = data;
    this.bookingRef = this.dialog.open(template, {
      width: '500px',
      disableClose: true,
      autoFocus: false
    })
  }

  getRates() {
    let obj = {
      from: this.queryParamsData?.origin?.id.toString(),
      to: this.queryParamsData?.destination?.id.toString(),
      liners: this.rateSearch?.liner?.id.toString(),
      cargo_ready_date: this.rateSearch?.departure_date,
      search_from: 'vessel_schedule',
      routing: !!this.rateSearch["via_route_id"] ? this.rateSearch["via_route_id"] : null
    }
    this.isLoading = true;
    this.getQueryInfo(obj);
    this.apiPortalService.getRateSearch(obj).subscribe(res => {
      if (res.statusCode == 200) {
        this.isLoading = false;
        this.rateList = res.info;
        this.chargeListObj.freight_charge = !!res.info.liner_service_cost_category ? res.info.liner_service_cost_category : null;
        this.chargeListObj.origin_charge = !!res.info.origin_charge ? res.info.origin_charge : null;
        this.chargeListObj.destination_charge = !!res.info.destination_charge ? res.info.destination_charge : null;

      }
    })
  }
  resSpecSearchObj: any;
  getQueryInfo(obj) {
    this.apiPortalService.getQueryParaInfo(obj).subscribe(res => {
      if (res.statusCode == 200) {
        let info = res.info;
        this.resSpecSearchObj = res.info;
        this.getObj.from = info.from ? info.from : null;
        this.getObj.to = info.to ? info.to : null;
        this.getObj.containers = !!info.containers ? info.containers : [];
        this.getObj.liners = !!info.liners ? info.liners : [];
        this.getObj.cargo_date = !!info.cargo_ready_date ? new Date(moment(info.cargo_ready_date).format("YYYY-MM-DD HH:mm:ss")) : new Date();
      }
    });
  }

  // createBooking() {
  //   let obj = <any>{};
  //   // obj["price_info"] = this.singleRate;
  //   // if ((!!this.singleRate.liner.id || !!this.singleRate.liner_id) && !!this.rateList.liner_service_cost_category[this.singleRate.liner_id ? this.singleRate.liner_id : this.singleRate.liner.id]) {
  //   //   obj["liner_charge"] = this.rateList.liner_service_cost_category[this.singleRate.liner_id ? this.singleRate.liner_id : this.singleRate.liner.id];
  //   // }
  //   obj = this.commonService.parseBookingStoreInfo(this.singleRate, this.chargeListObj.freight_charge, this.chargeListObj.origin_charge, this.chargeListObj.destination_charge, [], null);
  //   obj["vessel_schedule"] = this.rateSearch;
  //   this.apiPortalService.storeBookingInfo(obj).subscribe(res => {
  //     if (res.statusCode == 201) {
  //       this.route.navigate(['main/booking/create/', res.info]);
  //       this.close();
  //       this.bookingRef.close();
  //     }
  //   })
  // }

  createBook(templateName) {
    let obj = <any>{};
    obj = this.commonService.parseBookingStoreInfo(this.singleRate, this.chargeListObj.freight_charge, this.chargeListObj.origin_charge, this.chargeListObj.destination_charge, [], null);
    obj["vessel_schedule"] = this.rateSearch;
    if (!!location.pathname.includes("/vessel-schedules/")) {
      if (!!this.dialogRef) {
        this.dialogRef.close();
        this.bookingRef.close();
      }
      if (!!this.bottomSheetDialogRef) {
        this.bottomSheetDialogRef.dismiss();
        this.bookingRef.close();
      }
      if (!!localStorage.getItem("user") && !!localStorage.getItem("x-token")) {
        this.bookRoute(false, obj);
      } else {
        this.storeInLocalStorage();
        this.dialogRef = this.dialog.open(templateName, {
          // width: '940px'
        });
      }
    } else {
      this.bookRoute(true, obj);
    }
  }

  bookRoute(flag, obj) {
    this.apiPortalService.storeBookingInfo(obj).subscribe(res => {
      if (res.statusCode == 201) {
        if (flag) {
          this.route.navigate(['main/booking/create', res.info]);
        } else {
          if (!!localStorage.getItem("x-token") && !!localStorage.getItem("user")) {
            let token = localStorage.getItem("x-token");
            let navEx: any = {
              token: token,
              url: 'main/booking/create/' + res.info,
              isReqFrom: 'atmavaan',
              filter_type: this.queryParamsData?.filter_type || 'departure',
              from: this.queryParamsData?.from || null,
              to: this.queryParamsData?.to || null,
              origin: this.queryParamsData?.origin?.id || null,
              destination: this.queryParamsData?.destination?.id || null
            };
            const param: any = new URLSearchParams(navEx).toString();
            let url = `https://app.atmavaan.com/redirect?${param}`;
            window.open(url, "_self");
          }

        }
      }
    })
  }

  storeInLocalStorage() {
    let obj = <any>{};
    obj = this.commonService.parseBookingStoreInfo(this.singleRate, this.chargeListObj.freight_charge, this.chargeListObj.origin_charge, this.chargeListObj.destination_charge, [], null);
    obj["vessel_schedule"] = this.rateSearch;
    localStorage.setItem("selected_price", JSON.stringify(obj));
  }

  loginHandle(e: any, templateName: any) {
    if (e == 'login_success') {
      if (!!localStorage.getItem("user")) {
        this.userInfo = JSON.parse(localStorage.getItem("user") || "{}")
      }
      this.checkAndRedirect();
      // location.reload();
    } else if (e == 'close') {
    }
    this.dialogRef.close();
  }

  checkAndRedirect() {
    let token = localStorage.getItem("x-token");
    if (!!localStorage.getItem("selected_price")) {
      let obj = JSON.parse(localStorage.getItem("selected_price") || "");
      this.bookRoute(false, obj)
      // this.store();
    }
    else {
      let navEx: any = {
        filter_type: this.queryParamsData?.filter_type || 'departure',
        from: this.queryParamsData?.from || null,
        to: this.queryParamsData?.to || null,
        origin: this.queryParamsData?.origin?.id || null,
        destination: this.queryParamsData?.destination?.id || null
      };
      const param: any = new URLSearchParams(navEx).toString();
      let url = `https://www.atmavaan.com/vessel-schedules/${navEx.origin}/${navEx.destination}?${param}`;
      window.open(url, "_self");
    }
  }

  createBooking() {
    let obj = <any>{};
    obj = this.commonService.parseBookingStoreInfo(this.singleRate, this.chargeListObj.freight_charge, this.chargeListObj.origin_charge, this.chargeListObj.destination_charge, [], null);
    obj["vessel_schedule"] = this.rateSearch;
    if (this.DomainType == 'website') {
      this.dialogRef.close();
      this.bookingRef.close();
      let token = localStorage.getItem("x-token");
      if (!!token) {
        this.apiPortalService.storeBookingInfo(obj).subscribe(res => {
          if (res.statusCode == 201) {
            let url = "https://app.atmavaan.com/main/booking/create/" + res.info;
            window.open(url, "_self");
            this.close();
            this.bookingRef.close();
          }
        })
      }
    } else {
      this.apiPortalService.storeBookingInfo(obj).subscribe(res => {
        if (res.statusCode == 201) {
          this.route.navigate(['main/booking/create/', res.info]);
          this.close();
          this.bookingRef.close();
        }
      })
    }
  }


  openRateRequestDialog(templateName) {
    this.parseRequestObj();
    const dialogPosition: DialogPosition = {
      top: '0px',
      right: '0px'
    };

    this.reqDialogRef = this.dialog.open(templateName, {
      width: '550px',
      height: '100%',
      position: dialogPosition
    });

    this.dialogRef.afterClosed().subscribe(result => {
    });
  }
  rateFromtoObj: any;
  parseRequestObj() {
    console.log(this.queryParamsData)
    this.rateFromtoObj = this.resSpecSearchObj;
    this.rateFromtoObj["vessel_name"] = !!this.rateSearch["vessel_name"] ? this.rateSearch["vessel_name"] : null;
    if (!!this.dialogRef) {
      this.dialogRef.close()
    }
    if (!!this.bottomSheetDialogRef) {
      this.bottomSheetDialogRef.dismiss();
    }
  }
  openRateRequstBottomSheet(template) {
    this.parseRequestObj();
    this.bottomSheetDialogRef = this._bottomSheet.open(template);
  }
  submitRateRequest(templateName) {
    if (!!this.dialogRef) {
      this.dialogRef.close();
    }
    this.reqDialogRef.close();
    let getObj = {
      "from": this.rateList?.from_to?.from?.id,
      "to": this.rateList?.from_to?.to?.id,
      "limit": "10",
      "cargo_ready_date": this.rateSearch?.departure_date,
      "containers": "",
      "liners": "",
      "routing": "",
      "sort_by": "rate_low",
      "search_id": this.rateList?.search_id,
      "weight": null
    }
    this.apiPortalService.createRateRequest(getObj).subscribe(res => {
      if (res.statusCode == 201) {
        this.rateRequestInfo = res.info;
        this.reqDialogRef = this.dialog.open(templateName, {
          width: '500px'
        });
      }
    })
  }

  openRequest() {
    if (!!this.reqDialogRef) {
      this.reqDialogRef.close();
    }
    if (!!this.bottomSheetDialogRef) {
      this.bottomSheetDialogRef.dismiss();
    }
    this.route.navigate(['main/rates/rate-request/id'], { queryParams: { selectedId: this.rateRequestInfo.id } });
  }

  // for composing the mail
  isMobile() {
    var userAgent = navigator.userAgent || navigator.vendor;
    return (/android|avantgo|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ipad|iphone|ipod|iris|kindle|maemo|midp|mmp|mobile|nokia|palm|phone|pie|plucker|pocket|psp|series60|silk|smartphone|symbian|treo|up\.browser|up\.link|webos|wos/i.test(userAgent));
  }

  composeEmail() {
    var email = 'csindia@atmavaan.com';
    var subject = 'Requesting to get a vessel schedule - reg';
    var body = `Port pairs that I have selected POL : ${this.getObj?.from}, POD : ${this.getObj?.to}`;

    if (this.isMobile()) {
      var mailto_link = 'mailto:' + email;
      window.open(mailto_link, '_blank');
    } else {
      var gmail_link = 'https://mail.google.com/mail/?view=cm&fs=1&to=' + encodeURIComponent(email) + '&su=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      window.open(gmail_link, '_blank');
    }
  }

}
